<template>
  <div class="message-watcher">
    <search-users @userSelected="handleUserSelected" />
    <div v-if="isLoading" class="lds-grid">
      <div class="lds-ripple"><div></div><div></div></div>
      <p>Loading notifications...</p>
    </div>
    <div class="notifications" v-if="!isLoading && notifications.length">
      <div class="portal-notification" v-for="(notification, index) in notifications" :key="index">
        <a :href="notification.isSenderSupport
          ? '/dashboard/patients/' + (notification.recipients.length > 0 ? notification.recipients[0] : '')
          : '/dashboard/patients/' + notification.sender_id + '?mark=true'">
          {{ notification.sender_name }}
        </a> -
        <span class="message-watcher-notification-date">{{ localTime(notification.dateCreated.date) }}</span>
      </div>

      <div class="message-watcher-next" v-if="!isSearchActive">
        <div class="pagination gap-2">
          <span v-if="page > 0" @click="prevPage" class="click-effect">
            <i class="fas fa-chevron-left"></i>Prev
          </span>
          <span v-if="page < totalPages - 1" @click="nextPage" class="click-effect">
            Next<i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>

      <div class="pagination-info" v-if="!isSearchActive"></div>

      <button class="custom-action-button" @click="lookForNewMessages(true)">
        Last Page
      </button>
      <div class="pagination-info">
        <div class="pagination-info-item">
          <p>Current Page: {{ page + 1 }}</p>
        </div>
        <div class="pagination-info-item-2">
          <p>Pages: {{ totalPages }}</p>
          <p>Items: {{ totalItems }}</p>
        </div>
      </div>
    </div>
    <div v-else-if="!isLoading">
      There are no new messages.
    </div>
  </div>
</template>

<style scoped>
.message-watcher-next {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-action-button {
  display: flex;
  justify-self: flex-end;
  background-color: #243153;
  color: white;
  padding: 8px 14px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}
.custom-action-button:hover {
  background-color: #1a223a;
}
.pagination-info-item-2 p {
  margin: 0;
}
.pagination-info-item-2 {
  display: flex;
  justify-content: space-around;
}
.message-watcher-next {
  padding: 20px;
  display: flex;
  justify-content: center;
}
.message-watcher-notification-date {
  color: #949494;
  font-size: 12px;
}
.gap-2 {
  gap: 50px;
}
.lds-grid {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  justify-content: center;
}
.lds-ripple,
.lds-ripple div {
  box-sizing: border-box;
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #243153;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 80px;
    height: 80px;
    opacity: 0;
  }
}
.lds-grid p {
  color: #243153;
}
.pagination-info {
  text-align: center;
  margin-top: 10px;
}
.click-effect {
  cursor: pointer;
  transition: transform 0.1s ease-in-out;
}
.click-effect:active {
  transform: scale(0.95);
}
</style>

<script>
import axios from 'axios';
import moment from 'moment';
import { EventBus } from './event-bus';
import SearchUsers from './SearchUsers.vue';

export default {
  components: {
    SearchUsers,
  },
  props: {
    inputName: {
      type: [String, Boolean],
    },
    prepopulate: {
      type: [String, Boolean],
    },
  },
  data: function () {
    return {
      notifications: [],
      pollingInterval: 100000,
      newMessages: [],
      page: 0,
      isLoading: false,
      totalPages: 0,
      totalItems: 0,
      selectedCategory: '',
      isSearchActive: false,
    };
  },
  mounted() {
    EventBus.$on('product-category-selected', (category) => {
      this.selectedCategory = category;
      this.page = 0;
      this.isSearchActive = false; // reset search mode
      this.lookForNewMessages();
    });

    this.lookForNewMessages();
  },
  methods: {
    loadProductCategories() {
      axios
        .get('/api/v1/product-categories')
        .then((response) => {
          this.productCategories = response.data.data;
        })
        .catch((error) => {
          console.error('Error loading product categories:', error);
        });
    },
    nextPage() {
      if (this.isSearchActive) return; // disable pagination in search mode
      this.page++;
      this.lookForNewMessages();
    },
    prevPage() {
      if (this.isSearchActive) return; // disable pagination in search mode
      this.page--;
      this.lookForNewMessages();
    },
    lookForNewMessages: function(lastPage) {
      this.isLoading = true;
      this.isSearchActive = false;


      if (lastPage) {
        this.page = this.totalPages-1
      }
      let url = `/api/v1/messages/unread?page=${this.page}`;
      // Build the URL with query parameters

      // Add category filter if selected
      if (this.selectedCategory) {
        url += `&category=${this.selectedCategory}`;
      }

      axios
          .get(url)
          .then((response) => {
            if (response.data.data) {
              if (!response.data.data.data) {
                this.newMessages = [];
              }else{
                this.newMessages = response.data.data.data;
              }
              this.processNewMessages();
              this.totalPages = response.data.pagination.totalPages;
              this.totalItems = response.data.pagination.totalItems;
            } else {
              this.newMessages = [];
              this.notifications = [];
            }
          })
          .catch((error) => {
            console.error('Error fetching messages:', error);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    processNewMessages() {
      this.notifications = this.newMessages.map((message) => ({
        patient_id: message.patientId,
        sender_id: message.sender.id,
        sender_name: `${message.sender.firstName} ${message.sender.lastName}`,
        dateCreated: message.dateCreated,
        isSenderSupport: message.isSenderSupport,
        recipients: message.recipients || [],
      }));
    },
    localTime(datetime) {
      datetime = datetime.replace(/\.000000/, '');
      const utcDate = moment.utc(datetime);
      return moment(utcDate).local().calendar('', { sameElse: 'M/D/YYYY, h:mm A' });
    },
    handleUserSelected(userNotifications) {
      console.log(userNotifications)
      if (!userNotifications || userNotifications.length === 0) {
        this.page = 0;
        this.isSearchActive = false;
        this.lookForNewMessages();
        return;
      }

      this.isSearchActive = true;
      this.notifications = userNotifications.map((message) => ({
        sender_id: message.sender.id,
        sender_name: `${message.sender.firstName} ${message.sender.lastName}`,
        dateCreated: message.dateCreated,
      }));
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/MessageWatcher.vue